module.exports = __webpack_public_path__ + "static/media/gr.d2000201.webp";